<template>
  <div>
    <div>
      <h1>会員プラン</h1>
      <p class="p1">HRBOXは現在、様々な機能を開発しています。全てのプランを無料でお試しいただけます。</p>
    </div>

    <!-- form-1 -->
    <div class="register-container0">
      <el-form :rules="rules" :model="registerForm" ref="registerForm" v-loading="loading">
        <h2 class="register_title">スタートアッププラン</h2>
        <el-form-item prop="plan">
          <p class="p2">従業員情報の一元管理や業務のペーパーレス化・効率化をしたい方向けのプラン</p>
          <el-button type="success" @click="message()" round>このプランを選択</el-button>
        </el-form-item>
        <el-form-item>
          <p class="p3">※ 従業員数30名以下の企業向け</p>
          <p class="p3">&nbsp;</p>
        </el-form-item>

        <el-button class="el-icon-caret-left" type="text" @click="jump('/')">{{$t("register.return_login")}}</el-button>
        <el-form-item style="width: 100%">
          <el-button type="primary" @click="jump1('/register')" style="width: 90%;">¥12,000/月～（初期導入費用 ¥50,000）</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- form-2 -->
    <div class="register-container2">
      <el-form :rules="rules" :model="registerForm" ref="registerForm" v-loading="loading">
        <h2 class="register_title">スタンダードプラン</h2>
        <el-form-item prop="planB">
          <p class="p2">最新の従業員情報を収集・蓄積・活用できるスタンダードなプラン</p>
          <el-button type="success" @click="message()" round>このプランを選択</el-button>
        </el-form-item>
        <el-form-item>
          <p class="p3">※ 従業員数30名から200名までの企業向け</p>
          <p class="p3">&nbsp;</p>
        </el-form-item>

        <el-button class="el-icon-caret-left" type="text" @click="jump('/')">{{$t("register.return_login")}}</el-button>
        <el-form-item style="width: 100%">
          <el-button type="primary" @click="jump2('/register')" style="width: 90%;">¥25,000/月～（初期導入費用 ¥200,000）</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- form-3 -->
    <div class="register-container3">
      <el-form :rules="rules" :model="registerForm" ref="registerForm" v-loading="loading">
        <h2 class="register_title">プロフェッショナルプラン</h2>
        <el-form-item prop="planA">
          <p class="p2">従業員サーベイやラクラク分析レポートによる人事データを活用したい方向けのプラン</p>
          <el-button type="success" @click="message()" round>このプランを選択</el-button>
        </el-form-item>
        <el-form-item>
          <p class="p3">※ 従業員数200名以上の企業向け</p>
          <p class="p3">※ 複数企業の管理が可能</p>
        </el-form-item>

        <el-button class="el-icon-caret-left" type="text" @click="jump('/')">{{$t("register.return_login")}}</el-button>
        <el-form-item style="width: 100%">
          <el-button type="primary" @click="jump3('/register')" style="width: 90%;">¥30,000/月～（初期導入費用 ¥400,000）</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { postRequest } from "../utils/api";
import { putRequest } from "../utils/api";
export default {
  data() {
    return {
      plan: "",
      rules: {},
      checked: true,
      registerForm: {},
      loading: false,
    };
  },
  methods: {
    message() {
      this.$message.success('システムは無料トライアル中です、他の会員プランをお楽しみに！');
    },
    jump(path) {
      this.$router.push(path);
    },
    jump1(path) {
      this.$router.push({
        path: path,
        query: {
          plan: "a",
        },
      });
      console.log(plan);　//不加console.log请求的url中没有plan的值？？
      // this.$router.replace(path);
    },
    jump2(path) {
      this.$router.push({
        path: path,
        query: {
          plan: "a",
        },
      });
      console.log(plan);
      // this.$router.replace(path);
    },
    jump3(path) {
      this.$router.push({
        path: path,
        query: {
          plan: "a",
        },
      });
      console.log(plan);
      // this.$router.replace(path);
    },
    submitClick: function () {
      var _this = this;
      this.loading = true;
      if (this.registerForm.password == this.registerForm.password2) {
        postRequest("/reg", {
          username: this.registerForm.username,
          password: this.registerForm.password,
          email: this.registerForm.email,
        }).then(
          (resp) => {
            _this.loading = false;
            if (resp.status == 200) {
              //成功
              var json = resp.data;
              if (json.status == "success") {
                _this.$i18n.locale = json.locale;

                _this.$alert(
                  this.$t("register.registerAlert"),
                  this.$t("register.success")
                );

                // _this.$router.replace({ path: "/" });
              } else if (json.status == "usernameError") {
                _this.$alert(
                  this.$t("register.userAlert"),
                  this.$t("register.fail")
                );
              } else if (json.status == "emailError") {
                _this.$alert(
                  this.$t("register.emailAlert"),
                  this.$t("register.fail")
                );
              }
            } else {
              //失敗
              _this.$alert(
                this.$t("register.registerFail"),
                this.$t("register.fail")
              );
            }
          },
          (resp) => {
            _this.loading = false;
            _this.$alert(
              this.$t("register.server_not_found"),
              this.$t("register.fail")
            );
          }
        );
      } else {
        _this.loading = false;
        _this.$alert(
          this.$t("register.passwordFail"),
          this.$t("register.fail")
        );
      }
    },
  },
};
</script>
<style scoped>
.register-container0 {
  border-radius: 15px;
  background-clip: padding-box;
  margin-top: 39px;
  margin-right: 20px;
  width: 350px;
  height: 450px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  display: inline-block;
}

.register-container2 {
  border-radius: 15px;
  background-clip: padding-box;
  margin-top: 39px;
  /* margin-right: 20px; */
  width: 350px;
  height: 450px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  display: inline-block;
}

.register-container3 {
  border-radius: 15px;
  background-clip: padding-box;
  margin-top: 39px;
  margin-left: 20px;
  width: 350px;
  height: 450px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  display: inline-block;
}

.register_title {
  margin-bottom: 15px;
  text-align: center;
}

.register_remember {
  margin: 0px 0px 35px 0px;
  text-align: left;
}
.p1 {
  margin: 1px auto;
  width: 420px;
}
.p2 {
  margin: 1px auto;
  width: 300px;
  text-align: center;
  font-weight: 600;
}

.p3 {
  margin: 1px auto;
  width: 300px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/RegisterSelect.vue